export default {"src":"/_next/static/media/logo-color-white.7b665bfa.svg","height":254,"width":1646};